import React from 'react';
import { motion } from 'framer-motion';
import { RocketIcon, ListIcon, MegaphoneIcon, UsersIcon, TrendingUpIcon, ShieldIcon, HeadphonesIcon } from 'lucide-react';
const nodes = [{
  icon: RocketIcon,
  label: 'Onboarding',
  description: 'Echipare completă',
  color: 'from-[#357BEB] to-[#2868d8]'
}, {
  icon: ListIcon,
  label: 'Liste',
  description: 'Proprietari & Clienți',
  color: 'from-[#2868d8] to-[#1e5bb8]'
}, {
  icon: MegaphoneIcon,
  label: 'Promovare',
  description: 'Nelimitată & plătită',
  color: 'from-[#1e5bb8] to-[#132C53]'
}, {
  icon: UsersIcon,
  label: 'Leaduri',
  description: 'Alocate automat',
  color: 'from-[#132C53] to-[#21A366]'
}, {
  icon: TrendingUpIcon,
  label: 'Step by Step',
  description: 'Metodologie testată',
  color: 'from-[#21A366] to-[#1a8555]'
}, {
  icon: ShieldIcon,
  label: 'Legal',
  description: 'Protecție juridică',
  color: 'from-[#1a8555] to-[#357BEB]'
}, {
  icon: HeadphonesIcon,
  label: 'Suport 7/7',
  description: 'AI + Live Support',
  color: 'from-[#357BEB] to-[#2868d8]'
}];
export function FlowchartSection() {
  return <div className="bg-gradient-to-br from-gray-50 to-white rounded-2xl p-8 shadow-md" data-id="element-933">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6" data-id="element-934">
        {nodes.map((node, index) => <motion.div key={node.label} initial={{
        opacity: 0,
        scale: 0.8
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4,
        delay: index * 0.1
      }} className="relative" data-id="element-935">
            <div className="bg-white rounded-2xl p-6 shadow-md hover:shadow-xl transition-all border-2 border-transparent hover:border-[#357BEB]" data-id="element-936">
              <div className={`w-16 h-16 rounded-2xl bg-gradient-to-br ${node.color} flex items-center justify-center mb-4 shadow-lg mx-auto`} data-id="element-937">
                <node.icon className="w-8 h-8 text-white" data-id="element-938" />
              </div>
              <h3 className="text-lg font-bold text-[#132C53] text-center mb-2" data-id="element-939">
                {node.label}
              </h3>
              <p className="text-sm text-gray-600 text-center" data-id="element-940">
                {node.description}
              </p>
            </div>
            {index < nodes.length - 1 && <div className="hidden xl:block absolute top-1/2 -right-3 w-6 h-0.5 bg-[#357BEB] transform -translate-y-1/2" data-id="element-941"></div>}
          </motion.div>)}
      </div>
    </div>;
}